import React, { useContext } from "react";
import { LinkContainer } from "react-router-bootstrap";
import { UI } from "@wwimmo/ui";
import { observer } from "mobx-react";
import classes from "./Backnavigation.module.css";
import { RootStoreContext } from "src/stores/RootStore";
import { ColorStyle } from "src/utils/Colors";
import { ScreenWidth } from "src/stores/UIStore";

export const BacknavigationBase = () => {
    const { navStore } = useContext(RootStoreContext);

    if (!navStore.back && window.innerWidth <= ScreenWidth.SM) {
        return (
            <span>
                <span className={classes.BacknavigationLabelMobile}>{navStore.appheaderTitle}</span>
            </span>
        );
    } else if (!navStore.back) {
        return <></>;
    } else {
        const backToUrl = navStore.back.to.includes("?t=")
            ? navStore.back.to
            : `${navStore.back.to}${window.location.search}`;

        return (
            <LinkContainer className={`${classes.Backnavigation} cursor-pointer`} to={backToUrl}>
                <span>
                    <UI.Icon icon={UI.SVGIcon.ChevronLeft} color={ColorStyle("white")} />
                    <span className={classes.BacknavigationLabel}>{navStore.back.label}</span>
                    <span className={classes.BacknavigationLabelMobile}>{navStore.appheaderTitle}</span>
                </span>
            </LinkContainer>
        );
    }
};

export const Backnavigation = observer(BacknavigationBase);
